import styled, { css } from "styled-components"
import { Link } from "gatsby"

import { maxWidth } from "utils"

import CloudinaryImage from "components/cloudinary-image"

export const AstroHeader = styled.section`
  ${({ isArticle }) =>
    isArticle &&
    css`
      top: 0;
      left: 0;
      width: 100%;
      margin: 0 auto 2rem;
      padding: 2.2rem 1.7rem;
      display: flex;
      justify-content: center;
      background: #f6f6f6;
      overflow-x: auto;

      > :first-child {
        padding-left: 27px;
      }

      > :last-child {
        margin-right: 0;
        border-right: none;
      }

      ${maxWidth.desktopL`
        padding-left: 7rem;
      `}

      ${maxWidth.rightRail`
        justify-content: center;
      `}

      ${maxWidth.tablet`
        width: 100%;
        padding-left: 0;
        justify-content: flex-start;
      `}
    `}
`

export const CardsContainer = styled.div`
  ${({ isArticle }) =>
    isArticle
      ? css`
          width: 102.5rem;
          display: flex;
          justify-content: flex-start;

          > :last-child {
            border-right: none;
            margin-right: 0;
          }

          ${maxWidth.rightRail`
            width: 72.5rem;
            justify-content: center;
          `}

          ${maxWidth.tablet`
            justify-content: flex-start;
          `}
        `
      : css`
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          padding: 2.2rem 1.7rem;
          display: flex;
          justify-content: center;
          background: #f6f6f6;
          overflow-x: auto;

          > :last-child {
            margin-right: 0;
            border-right: none;
          }

          ${maxWidth.mobile`
            top: 0;
            padding-left: 2rem;
            justify-content: flex-start;
          `}
        `}
`

export const AstroHeaderCard = styled(Link)`
  display: flex;
  align-items: center;
  border-right: 2px solid #dddddd;
  padding-right: 2.4rem;
  margin-right: 3.6rem;
  flex: 0 1 auto;
  max-width: 30rem;

  h4 {
    font-weight: 500;
    font-size: 1.4rem;
  }

  p {
    font-size: 1.4rem;
    line-height: 1.6rem;
    color: #666666;
    margin: 0;
    margin-top: 0.3rem;
  }

  @media (max-width: 1024px) {
    flex: 1 0 auto;
  }
`

export const AstroHeaderImage = styled(CloudinaryImage)`
  margin-right: 1.3rem;
  flex: 0 0 auto;
  width: 5.6rem;
  height: 5.6rem;
`
